<div class="event-card-summary" [attr.aria-hidden]="placeholder ? true : null">
  <h2 class="event-card-summary__title font-medium muted-text"
      [pTooltip]="event?.name" [tooltipDisabled]="placeholder || !event?.name"
      tooltipEvent="both" appendTo="body" [attr.tabindex]="!placeholder && event?.name ? 0 : null">
    <ng-container *ngIf="!placeholder; else titleSkeleton">{{ event?.name }}</ng-container>
  </h2>
  <div class="event-card-summary__dates text-sm muted-text">
    <ng-container *ngIf="!placeholder; else datesSkeleton">
      <ng-container *ngIf="firstDate?.start">
        <div class="event-card-summary__date-line">
          {{ firstDate.start | date: 'HH:mm' }}<ng-container *ngIf="lastDate?.end"> - {{ lastDate.end | date: 'HH:mm' }}</ng-container>
        </div>
        <div *ngIf="event.eventDates.length === 1" class="event-card-summary__date-line">
          {{ firstDate.start | date: 'EEEE, d MMMM y' }}
        </div>
        <div *ngIf="event.eventDates.length > 1" class="event-card-summary__date-line">
          {{ firstDate.start | date: 'EEE, d MMM' }}<ng-container *ngIf="lastDate?.end"> - {{ lastDate.end | date: 'EEE, d MMM y' }}</ng-container>
        </div>
      </ng-container>
    </ng-container>
  </div>
  <div class="event-card-summary__location text-sm muted-text"
       [pTooltip]="location" [tooltipDisabled]="placeholder || !location"
       tooltipEvent="both" appendTo="body" [attr.tabindex]="!placeholder && location ? 0 : null">
    <ng-container *ngIf="!placeholder; else locationSkeleton">{{ location }}</ng-container>
  </div>
</div>

<ng-template #titleSkeleton>
  <span class="event-card-summary__skeleton-line"><p-skeleton width="90%" height=".9rem"></p-skeleton></span>
  <span class="event-card-summary__skeleton-line"><p-skeleton width="65%" height=".9rem"></p-skeleton></span>
</ng-template>
<ng-template #datesSkeleton>
  <span class="event-card-summary__skeleton-line"><p-skeleton width="55%" height=".75rem"></p-skeleton></span>
  <span class="event-card-summary__skeleton-line"><p-skeleton width="85%" height=".75rem"></p-skeleton></span>
</ng-template>
<ng-template #locationSkeleton>
  <span class="event-card-summary__skeleton-line"><p-skeleton width="80%" height=".75rem"></p-skeleton></span>
  <span class="event-card-summary__skeleton-line"><p-skeleton width="50%" height=".75rem"></p-skeleton></span>
</ng-template>
